<template>
  <div>
    <el-upload :action="uploadUrl" :accept="accept" :on-remove="handleRemove" :on-success="handSuccess"
      :on-exceed="handExceed" :limit="1" :file-list="fileList" ref="upload" :before-upload="beforeUpload"
        :headers="getUploadHeaders()">
      <!-- <template v-if="!fileId"> -->
      <span style="color: #632b91" v-if="accept=='.doc,.docx'">点击上传（支持word格式上传)</span>
      <span style="color: #632b91" v-else-if="accept=='.pdf'">点击上传（支持pdf格式上传)</span>
      <span style="color: #632b91" v-else>点击上传（支持word,pdf格式上传)</span>
      <!-- </template> -->
    </el-upload>
  </div>
</template>

<script>
  import { Toast } from "vant"
  import { getPZUrl, paperFileDelete } from "@/api/dictionary";
  import { fileuploadUrl } from "@/api/upload";
  export default {
    model: {
      prop: "fileId",
      event: "change"
    },
    props: {
      fileId: String,
      form: Object,
      fileName: String
    },
    components: {
      [Toast.name]: Toast,
    },
    data() {
      return {
        fileList: [],
        accept: '',
        uploadUrl: fileuploadUrl
      };
    },
    created() {
      if (this.fileId) {
        this.fileList = [{ name: this.fileName }]
      }
      console.log('fileId', this.fileId)
      let meetingDetailsItem = JSON.parse(sessionStorage.getItem("meetingDetails"));
      let paperDetails = JSON.parse(sessionStorage.getItem("paperDetails"));
      this.accept = paperDetails.fileType;
    },
    methods: {
      handleRemove: function (file, fileList) {
        if (this.fileId) {
          this.$emit('change', null)
          this.$emit('setFileName', null)
          // let params = {
          //   meetingPaperId: this.fileId,
          //   fileId: this.fileId
          // };

          // paperFileDelete(params).then(() => {
          //   this.$emit('change', null)
          //   this.$emit('setFileName', null)
          //   Toast.success('删除成功')
          // }).catch(() => {
          //   this.fileList = [{ name: this.form.fileName }]
          // });
        }

      },
      beforeUpload(file) {
        if (this.accept) {
          if (file.type == '') {
            Toast.fail("上传文件后缀名不正确!");
            return false
          }
          let arr = this.accept.split(",");
          const fileType = file.name.substring(file.name.lastIndexOf("."));
          console.log("12212121",fileType)
          if (arr.indexOf(fileType) == -1) {
            Toast.fail("上传文件类型不正确!");
            return false
          }
        } else {
          let arr = ['.doc', '.pdf', '.docx'];
          const fileType = file.name.substring(file.name.lastIndexOf("."));
          if (arr.indexOf(fileType) == -1) {
            Toast.fail("上传文件类型不正确!");
            return false
          }

        }


      },
      handSuccess(res, file, fileList) {
        if (res.success) {
          this.$emit('change', res.result.id)
          this.$emit('setFileName', res.result.fileName)
          this.btnState = false;
          Toast.success('上传成功')
        }
      },
      handExceed(files, fileList) {
        Toast.warning(`当前限制选择 3 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      }
    }
  };
</script>

<style scoped lang="less">
  .hide .el-upload--picture-card {
    display: none;
  }
</style>